import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.netural100};
  margin-top: 4rem;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 2px 0px rgba(24, 30, 45, 0.05),
    0px 0px 10px 0px rgba(64, 56, 95, 0.05),
    0px 0px 40px 0px rgba(81, 94, 108, 0.05);
  border-radius: 8px;
  padding: 40px;
  width: 636px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 32px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
    padding: 20px;
  }
`;

export const Title = styled.h2`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 34px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin-top: 40px;
  margin-bottom: 24px;
`;

export const Description = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.netural800};
  text-align: center;
  margin-bottom: 40px;
`;

export const InfoBox = styled.div`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.netural300};
  border-radius: 8px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 636px;
  @media (max-width: ${({ theme }) => theme.breakpoints.s}px) {
    width: 100%;
    padding: 20px;
  }
`;

export const InfoTitle = styled.h3`
  font-family: "Archivo", sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: ${({ theme }) => theme.colors.primary600};
  text-align: center;
  margin: 24px 0 8px 0;
`;

export const InfoDescription = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.netural800};
  text-align: center;
  margin-bottom: 24px;
`;
